import PropTypes from "prop-types";
import "./CarouselArrow.scss";
import { memo } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

export const ARROW_DIRECTION = {
	LEFT: "left",
	RIGHT: "right",
};

const CarouselArrow = props => {
	const {
		direction = ARROW_DIRECTION.LEFT,
		hidden = false,
		onClick = () => {},
		className = "",
		size,
	} = props;
	return (
		!hidden && (
			<div
				className={`carousel-arrow ${className}`}
				onClick={onClick}
				data-testid={props["data-testid"]}
			>
				{direction === ARROW_DIRECTION.LEFT ? (
					<ArrowLeftIcon size={size} />
				) : (
					<ArrowRightIcon size={size} />
				)}
			</div>
		)
	);
};

CarouselArrow.propTypes = {
	direction: PropTypes.oneOf(["left", "right"]),
	hidden: PropTypes.bool,
	onClick: PropTypes.func,
	className: PropTypes.string,
	"data-testid": PropTypes.string,
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default memo(CarouselArrow);
